import { getDb } from './db';
import { AttemptSyncer } from './sync';

let syncer: AttemptSyncer | null = null;

/** Один синхронізатор на весь застосунок. Створюється лінько, живе до кінця вкладки. */
export function getSyncer(): AttemptSyncer {
  syncer ??= new AttemptSyncer({ db: getDb() });
  return syncer;
}

/**
 * Каже черзі, чия вона зараз.
 *
 * Планшет один на двох дітей і батька, база Dexie — одна на пристрій, а куку
 * сесії має лише той, хто увійшов останнім. Без цього виклику синхронізатор
 * не знає меж і здатен віддати відповіді Богдана під сесією Маркусі.
 *
 * Кликати треба на кожному вході та на кожному перемиканні профілю — і не
 * боятися зайвого виклику: та сама дитина двічі поспіль нічого не змінює.
 */
export function setActiveLearner(learnerId: string | null): void {
  getSyncer().switchLearner(learnerId);
}

/** Тільки для тестів. */
export function __setSyncerForTests(instance: AttemptSyncer | null): void {
  syncer = instance;
}
